import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="2.5" cy="2.5" r="1.5" fill="currentcolor"/><circle cx="13.5" cy="2.5" r="1.5" fill="currentcolor"/><circle cx="2.5" cy="8" r="1.5" fill="currentcolor"/><circle cx="13.5" cy="8" r="1.5" fill="currentcolor"/><circle cx="2.5" cy="13.5" r="1.5" fill="currentcolor"/><circle cx="13.5" cy="13.5" r="1.5" fill="currentcolor"/></svg>`;

export { symbol as default };
